export enum UserOperation {
  Create,
  Update,
  Delete,
  Cancel,
  Duplicate,
  None,
}
